import { siteStats } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20collage%20of%20society%20oddities%20from%20the%20US%20and%20Japan%2C%20vintage%20newspaper%20clippings%20and%20magazine%20texture%2C%20warm%20cream%20paper%20with%20vermillion%20red%20stamp%20marks%20and%20dark%20ink%20accents%2C%20abstract%20mysterious%20mood%2C%20high%20detail&width=1800&height=1000&seq=chigua-hero-main&orientation=landscape"
          alt="美日吃瓜 社会奇闻专题封面"
          title="美日吃瓜 · 社会奇闻与离奇案件专题"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85"></div>
      <div className="absolute inset-0 paper-grain opacity-40"></div>

      <div className="relative mx-auto flex min-h-[560px] w-full max-w-7xl flex-col justify-center px-4 pb-16 pt-32 md:min-h-[680px] md:px-10 md:pb-20 md:pt-40">
        <div className="w-full max-w-3xl animate-rise">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-100/30 bg-background-50/10 px-4 py-1.5 text-xs tracking-[0.2em] text-background-100 backdrop-blur">
            <i className="ri-fire-line text-accent-400"></i>
            每天两更 · 已收录 500+ 篇
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-6xl">
            美日吃瓜
            <span className="mt-3 block text-xl font-semibold text-background-200 md:text-3xl">
              美日社会奇闻与离奇案件合集
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-8 text-background-200 md:text-base">
            汇集美国与日本两国的社会奇闻、奇葩事件与迷惑行为。离奇案件、都市怪谈、民间传说持续收录，
            每一条都标注来源、区分事实与传闻，带你见识大千世界的无奇不有。
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#latest"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-compass-3-line"></i>
              开始吃瓜
            </a>
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-layout-grid-line"></i>
              浏览主题分类
            </a>
          </div>

          <div className="mt-12 flex flex-wrap gap-x-8 gap-y-5 border-t border-background-100/20 pt-7">
            {siteStats.map((stat) => (
              <div key={stat.label} className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-accent-400">
                  <i className={`${stat.icon} text-lg`}></i>
                </span>
                <span className="flex flex-col">
                  <span className="font-heading text-lg font-bold text-background-50">{stat.value}</span>
                  <span className="text-xs text-background-300">{stat.label}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}